import { BlockStack, Button, Icon, InlineStack, Spinner, Text, Tooltip } from "@shopify/polaris";
import { ChevronRightMinor, CircleAlertMajor, CircleCancelMajor, CircleTickMajor, ClockMinor, QuestionMarkInverseMinor } from "@shopify/polaris-icons";
import React, { useEffect, useRef, useState } from "react";

export const getProgressBarColor = (value: any) => {
    let colorValue: any = '';
    if (value < 70)
        colorValue = 'success';
    else if (value >= 70 && value < 90)
        colorValue = '';
    else colorValue = 'critical';

    return colorValue;
}

// FOrmat date in dd-mm-yyyy format
export const formattedDate = (date: string) => {
    const monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const [year, month, day] = date?.split(' ')?.[0]?.split('-');
    const dd = day + (['th', 'st', 'nd', 'rd'][parseInt(day) % 10 > 3 ? 0 : (parseInt(day) % 100 - 10 !== 0 && parseInt(day) % 10 < 4 ? parseInt(day) % 10 : 0)]);
    const mm = monthList[parseInt(month) - 1];
    const yy = year;
    const formattedDate = dd + ' ' + mm + ' ' + yy;
    return formattedDate;
}



interface TimeAgoOptions {
    showSeconds?: boolean;
    minimal?: boolean;
}

export function usePreciseTimeAgo(
    timestamp: string | Date | null | undefined,
    options: TimeAgoOptions = {}
): string {
    const [timeAgo, setTimeAgo] = useState<string>('Calculating...');
    const intervalRef = useRef<NodeJS.Timeout | null>(null);


    useEffect(() => {
        if (!timestamp) {
            setTimeAgo('Never updated');
            return;
        }

        // Parse timestamp as UTC regardless of system timezone
        const updatedUTC:any = typeof timestamp === 'string' ? new Date(timestamp) : timestamp
        console.log( updatedUTC.getTime(),"wsedrfvgtbyhnjm")

        const calculate = (): string => {
            const now = new Date(); // This is UTC by default
            const diff = now.getTime() - updatedUTC.getTime();

            console.log(diff,"wsedrfvgtbyhnjm")
            if (diff < 0) return 'Just now';

            const seconds = Math.floor(diff / 1000);
            const minutes = Math.floor(seconds / 60);
            const hours = Math.floor(minutes / 60);
            const days = Math.floor(hours / 24);

            if (options.showSeconds && seconds < 10) return 'Just now';
            if (options.showSeconds && seconds < 60)
                return `${seconds} second${seconds !== 1 ? 's' : ''} ago`;

            if (minutes < 60) {
                if (options.minimal && minutes < 1) return 'Just now';
                return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
            }

            if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
            if (days < 7) return `${days} day${days !== 1 ? 's' : ''} ago`;

            // Older than a week: fallback to date string
            return new Date(updatedUTC).toLocaleDateString();
        };

        const updateTime = () => {
            setTimeAgo(calculate());
        };

        // Initial run
        updateTime();

        const diffNow:any = Date.now() - updatedUTC;
        const updateInterval =
            diffNow < 60000 ? 1000 : // update every 1s if < 1 min
                diffNow < 3600000 ? 30000 : // every 30s if < 1 hour
                    60000; // every 1 min otherwise

        intervalRef.current = setInterval(updateTime, updateInterval);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [timestamp, options.showSeconds, options.minimal]);

    return timeAgo;
}

export function timeSinceLastUpdate(cachedAt: string): string {
    const now = new Date();
    const cachedDate = new Date(cachedAt);
    const diffInSeconds = Math.floor((now.getTime() - cachedDate.getTime()) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
  }




export const prepareCustomPrice = (customPrice: any, billingType: string) => {
    let price: React.ReactNode = <></>;
    price = <InlineStack blockAlign="baseline">
        <Text as="span" fontWeight="semibold">$</Text>
        <Text as='span' fontWeight="semibold">{customPrice}</Text>
        <Text as="span" tone="subdued">{billingType}</Text>
    </InlineStack>
    return price;
}

export const returnDiscountedPrice = (discounts: any, customPrice: any) => {
    let discountedPrice: number = +customPrice || 0;
    let tempPrice: number = +discountedPrice;
    discounts?.forEach((discount: any) => {
        switch (discount?.type) {
            case 'percentage':
                tempPrice = +tempPrice - (+discount?.value / 100) * +tempPrice;
                break;
            case 'fixed':
                tempPrice = +tempPrice - +discount?.value;
                break;
            default:
                tempPrice = tempPrice;
        }
    })
    return tempPrice;
}

export const pricingBadge = (tag: any): any => {
    return (
        <InlineStack gap="100" blockAlign='center'>
            <Text as="span" variant='bodySm'>Recommended</Text>
            <div style={{ cursor: 'pointer' }}>
                {
                    tag && tag !== "" &&
                    <Tooltip dismissOnMouseOut content={tag}>
                        <Icon source={QuestionMarkInverseMinor} tone='interactive' />
                    </Tooltip>
                }
            </div>
        </InlineStack>
    )
}

export const necessaryInfo = (props: any) => {
    return {
        "user_id": {
            "1": props.redux.user_id
        },
        "object_type": {
            "1": "source_order"
        },
        "marketplace": {
            "1": props.redux.current.target?.marketplace
        },
        "marketplace_shop_id": {
            "1": props?.redux?.current?.target?._id
        }
    }
}

export const getBopisInfo = () => {
    return {
        "filter_tags": {
            "1": 'ISPU'
        }
    }
}

// Format date in yyyy-mm-dd format
export const formatDate = (inputDate: any) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export const renderStatusCount = (count: number, loader: boolean, label?: string) => {
    return loader ?
        <div><Spinner accessibilityLabel="Small spinner example" size="small" /></div>
        :
        <Text as='p'>{label ? label + `: ${count || 0}` : `${count || 0}`}</Text>
}

export const getTargetCondition = (text: string) => {
    switch (text) {
        case "GREATER_THAN":
            return ">";
        case "LESS_THAN":
            return "<";
    }
}

export const getDuration = (data: any) => {
    let days: any = 0;
    if (data) {
        let from = new Date(data?.reportingDateRange?.reportingDateFrom);
        let to = new Date(data?.reportingDateRange?.reportingDateTo);
        let milliseconds = to.getTime() - from.getTime();
        days = milliseconds / (1000 * 3600 * 24);
    }
    return Math.round(days);
}

export const imageselction = (value: any) => {
    switch (value) {
        case "warning":
            return <div><Icon source={CircleAlertMajor} tone="warning" /></div>;
        case "attention":
            return <div><Icon source={CircleAlertMajor} tone="warning" /></div>;
        case "info":
            return <div><Icon source={CircleAlertMajor} tone="warning" /></div>;
        case "success":
            return <div><Icon source={CircleTickMajor} tone="success" /></div>;
        case "critical":
            return <div><Icon source={CircleCancelMajor} tone="critical" /></div>;
        default:
            return <div><Icon source={CircleAlertMajor} tone="warning" /></div>;
    }
}

export const returnActionName = (actionName: string, t: any) => {
    switch (actionName) {
        case 'failed_shipment':
            return t('Shipment Process Failure')
        case 'failed_order':
            return t("Order Creation Failure")
        case 'failed_refund':
            return t('Refund Process Failure')
        case 'failed_cancellation':
            return t('Cancellation Process Failure')
        case 'national_failed_return':
            return t('Return Process Failure')
    }
}

export const shipmentToBeDoneDesc = (actionName: string, t: any = "") => {
    switch (actionName) {
        case 'shipped_by_today':
            return t("To be shipped by today.")
        case 'ready_for_pickup':
            return t("Order is ready for pickup.")
        case 'shipped_by_tomorrow':
            return t('To be shipped by tomorrow.')
    }
}

export const getHiddenCarrierCode = (carrierCode: any) => {
    let hiddenString: string = "";
    if (Object.keys(carrierCode).length > 0 && carrierCode?.shopify_carrier_code !== undefined) {
        hiddenString = `XXXXXXX${carrierCode?.shopify_carrier_code?.slice(-4)}`
    }
    return hiddenString;
}
export function getTimeUntilExpiration(created_at: string): { hours: number, minutes: number, seconds?: number } {
    // Parse the created_at timestamp
    const createdAt: Date = new Date(created_at);

    // Current time
    const currentTime: Date = new Date();

    // Validity period in milliseconds (10 hours)
    const validityPeriod: number = 72 * 60 * 60 * 1000;

    // Calculate elapsed time
    const elapsedTime: number = currentTime.getTime() - createdAt.getTime();

    // Calculate remaining time
    const remainingTime: number = validityPeriod - elapsedTime;

    if (remainingTime < 0) {
        // If the remaining time is negative, set it to zero
        return { hours: 0, minutes: 0, seconds: 0 };
    }

    // Convert remaining time to hours, minutes, and seconds
    const remainingHours: number = Math.floor(remainingTime / (60 * 60 * 1000));
    const remainingMinutes: number = Math.floor((remainingTime % (60 * 60 * 1000)) / (60 * 1000));
    const remainingSeconds: number = Math.floor((remainingTime % (60 * 1000)) / 1000);


    // If less than a minute remaining, return hours, minutes, and seconds
    return { hours: remainingHours, minutes: remainingMinutes, seconds: remainingSeconds };

}


export function isLinkValid(created_at: string): boolean {
    // Parse the created_at timestamp
    const createdAt: Date = new Date(created_at);

    // Current time
    const currentTime: Date = new Date();

    // Validity period in milliseconds (10 hours)
    const validityPeriod: number = 72 * 60 * 60 * 1000;

    // Calculate elapsed time
    const elapsedTime: number = currentTime.getTime() - createdAt.getTime();

    // Check if elapsed time is within validity period
    return elapsedTime < validityPeriod;
}